export default {
    'en.page': {
        'invalid_phone_number': 'Invalid phone number',
        'required': 'This information is required',
        'yes': 'Yes',
        'no': 'No',
        'pcs': 'pcs',
        'missing': 'Missing',
        'uploaded': 'Uploaded',
        'save': 'Save',
        'addNew': 'Add new',
        'edit': 'Edit',
        'delete': 'Delete',
        'deleteTitle': 'Are you sure you want to delete this item?',
        'deleteDesc': 'This operation cannot be undone later!',
        'deleteDocument': 'Delete document',
        'ok': 'Ok',
        'aszf': 'General Terms and Conditions',
        'szep_card': '<b>SZÉP</b>, <b>EP</b> and <b>American Express</b>  cards are also accepted by our terminals due to contracts have been made before with these card issuers.',
        'szep_card_no_amex': 'Our terminals accept and handle all types of <b>SZÉP</b> and <b>EP</b> cards due to contracts have been made before with these card issuers.',
        'ic_sup_1': `<b><sup class="sup-1">1</sup></b> <b>Interchange Fee</b> this fee is the fee of the cardholder's bank (i.e. the bank that issued the customer's bank card), which starts at <b>0.2%</b> in case of consumer debit cards issued within Europe.`,
        'ic_sup_2': `<b><sup class="sup-2">2</sup></b> <b>Card Scheme Fee</b> this fee ranges from <b>0.15% to 0.65%</b>, depending on the value of a transaction. In case of a low-value transaction, this fee is higher, while in case of a high-value transaction, this fee is lower.`,
        'ic_sup_3': `<b><sup class="sup-3">3</sup></b> <b>Merchant Commission:</b>  In addition to the displayed merchant commission, an additional <b>0.7%</b> will be charged to cover average interchange fees and card scheme fees.<br>By the 15th of each month, eService will send a correction invoice for the actual interchange fees and card scheme fees of the previous, closed month. If the correction invoice is positive, it means that the previously deducted <b>0.7%</b> did not fully cover the costs, and the invoice total will be added to the next settlement. If the correction invoice is negative, the invoice total will be credited to the next settlement due to the fee discount.`,
        'offer_validity': `The offer is valid for 30 days only!`,
        'upload': 'Upload',
        'close': 'Close',
        'add_new_person': 'Add new person',
        "contact_plans_alert": {
            "preloaded_data": "We have preloaded from the central database the available authorized representatives (signatories) and ownership data, as well as the contact person registered during the inquiry. Please set the exact role of the person after pressing the Edit button! The same person can hold multiple roles.",
            "contact_person": "Contact person: who can be reached for contractual and other administrative matters, providing a phone number and email address is mandatory.",
            "authorized_representative": "Authorized representative: the contract signatory, which can be individual or joint. Enter the details of the authorized representative's documents in the appropriate fields after pressing the <strong>Edit</strong> button, and please upload copies of the documents!",
            "owner": "Owner: list all individuals with a <strong>25%</strong> or greater ownership stake! <br> Enter the details of these persons' documents in the appropriate fields after pressing the <strong>Edit</strong> button, and please upload copies of the documents! <br> Owners with less than a <strong>25%</strong> stake who do not hold any other roles generally do not need to be identified, and these persons can be deleted!",
        },
        'bankAccountInfo': {
            'individual_info': 'In case of a sole proprietorship, a personal bank account in the entrepreneur’s name can also be used.',
            'iban_info': 'We will transfer the amount of successful transactions, reduced by commission, to this bank account. Please provide the full IBAN!',
            'iban_help': `Can’t find the IBAN on your statement? <a href="https://www.iban.hu/calculate-iban" target="_blank" class="primary--text">Click here</a> to calculate your IBAN.`
        },
        'offer': {
            'title': 'Offer',
            'section1': {
                'title': 'The following factors were taken into account while preparing your offer:',
                'pos': {
                    'estimated_card_annual': 'Estimated bank card annual turnover',
                    'avg_ticket_value': 'ATV (Average Transaction Value)',
                },
                'vpos': {
                    'estimated_card_annual': 'Estimated VPOS annual turnover',
                    'avg_ticket_value': 'ATV (Average Transaction Value)',
                },
                'nr_of_terminals': 'Number of terminals, commincation type'
            },
            'section2': {
                'title': 'Bank Card acceptance Offer'
            },
            'reject': 'Reject',
            'rejected': 'Offer rejected',
            'accept': 'Accept',
            'accepted': 'Offer accepted',
            'info': 'I want to negotiate',
            'waitingInfo': 'Asked for negotiation',
            'egt': 'NON-EEA countries',
            'egt_link': 'https://en.wikipedia.org/wiki/European_Economic_Area',
            'eea': 'European Economic Area',
            'cardSchemeFee': 'Card Scheme Fee',
            'interCharge': {
                'visa': 'InterChange fee for Visa acceptance',
                'masterCard': 'InterChange fee for MasterCard acceptance',
            },
            'recommendedProduct': 'The recommended product for you'
        },
        'success': {
            'dataModification': 'DATA MODIFICATION',
            'thx': 'Thank you for accepting our offer!',
            'viaMail': 'You have recieved the offer via e-mail.',
            'redirect': `seconds <br> remaining until you are redirected to the next step.`,
            'nextStep': 'Go to next step',
        },
        'successSlovakia': {
            'title': 'Thank you!',
            'line_1': 'Dear Customer!',
            'line_2': 'Thank you for honoring us with your trust!',
            'line_3': 'The accepted payment acceptance offer has also been sent to you by e-mail.',
            'line_4': 'The next step is to prepare, finalize and sign your payment acceptance contract.',
            'line_5': 'To ensure that we can provide you with the service as soon as possible, please open the email and return the requested information and documents.',
            'line_6': 'If you have any questions, feel free to contact your sales contact!',
        },
        'dataRecording': {
            'title': 'Required Data for Contract',
            'contractData': 'Contract data',
            'finalSubmit': 'Save and Final Submit',
            'confirmFinalSubmit': 'Confirm final submission',
            'requestText': 'Please upload the necessary documents in the last step or choose to send them by e-mail.',
            'confirmText': 'Are you sure the information you entered is correct? After pressing the "Save and Final Submit" button, you can no longer change the data!',
            'uploadingDocuments': 'Uploading documents',
            'close': 'Close',
            'back': 'Back',
            'next': 'Next',
            'addNewShop': 'Add new acceptance point',
        },
        'taxNumber': {
            'title': 'Please enter your company\'s tax number',
            'label': 'TAX number',
            'specialLabel': 'Egyedi Adószám',
            'specialDesc': 'Egyedi adószám (például Őstermelői, vagy FEOR számmal rendelkezőknek)',
            'required': 'The tax number field is required!',
            'length': 'Az adószám hossza 11 karakter kell, hogy legyen.',
        },
        'gdpr': {
            'title': 'PRIVACY SETTINGS',
            'subtitle': 'GDPR SETTINGS',
            'next': 'Next',
        },
        'offerHelp': {
            'title': 'Thank you!',
            'description': 'Please respond to all open offers with the press of a button.',
        },
        'rejected': {
            'title': ' We\'re sorry!',
            'description': 'We\'re sorry that you didn\'t like our offer! In such cases, it might be worth contacting us again, since it is possible that we just did not receive enough information about your business. The more we know and the more accurate data we have, the better offer we can give you!',
            'contact': 'Contact information of your personal contact:',
        },
        'dcc': {
            'title': ' DCC statements',
            'subtitle': 'Merchants',
        },
        'login': {
            'title': 'CUSTOMER GATE',
            'password': 'Password',
            'remember_me': 'Remember me',
            'registration': 'New registration',
            'action': 'Login',
            'forgot_password': 'Forgot password',
            'tax_number_hint': 'First 8 characters of tax number',
        },
        'registration': {
            'title': 'IDENTIFICATION',
            'description_1': 'To create a password, please identify yourself by providing the first 8 characters of your tax number.',
            'description_2': 'To create a password, please identify yourself by providing your tax number.',
            'action': 'REQUEST',
            'back': 'Back',
        },
        'reset_password': {
            'title': 'RESET PASSWORD',

            'new_password': {
                'label': 'New Password',
                'rules': {
                    'required': 'The password is required.',
                    'length': 'The password must be at least 8 characters long.',
                },
            },

            'confirm_password': {
                'label': 'Confirm Password',
                'rules': {
                    'required': 'Password confirmation is required.',
                    'confirm': 'The password confirmation does not match.',
                },
            },

            'action': 'Set New Password'
        },
        "dashboard": {
            "shop": {
                "not_found": "There is currently no terminal in this store."
            }
        },
        'eula': {
            'title': 'Terms of Service',
            'description': 'General Terms and Conditions',
        },
        'phoneNumberFiled': {
            'example': 'Example',
            'searchPlaceholder': 'Search by country name or country code',
        },
        'acqCard': {
            'heading': 'Your contact person:',
            'thankYou': 'Thanks for your interest in our services',
            'provider': 'Your payment service provider',
        }

    },
    'hu.page': {
        'invalid_phone_number': 'Érvénytelen telefonszám',
        'required': 'Kötelezően kitöltendő mező',
        'yes': 'Igen',
        'no': 'Nem',
        'missing': 'Hiányzik',
        'uploaded': 'Feltöltve',
        'pcs': 'db',
        'ok': 'Rendben',
        'save': 'Mentés',
        'addNew': 'Új hozzáadása',
        'edit': 'Szerkesztés',
        'delete': 'Törlés',
        'deleteTitle': 'Biztosan törölni szeretnéd ezt az elemet?',
        'deleteDesc': 'Ez a müvelet késöbb nem visszavonható!',
        'deleteDocument': 'Dokumentum törlése',
        'aszf': 'Általános Szerződési Feltételek megtekintése',
        'szep_card': `Termináljaink kezelik a <b>SZÉP</b>, <b>Egészségpénztári</b> továbbá az <b>American Express</b> kártyákat is.<br>Ezen kártyák elfogadásának feltétele az adott kártyakibocsátóval történő szerződéskötés, melyben meghatározásra kerülnek az elfogadás során felmerülő díjak.`,
        'szep_card_no_amex': `Termináljaink elfogadnak és kezelnek minden típusú a <b>SZÉP- és Egészségpénztári kártyát</b>.<br>Ezen kártyák elfogadásának feltétele az adott kártyakibocsátóval történő szerződéskötés, melyben meghatározásra kerülnek az elfogadás során felmerülő díjak.`,
        'ic_sup_1': `<b><sup class="sup-1">1</sup></b> <b>Bankközi jutalék</b> (Interchange Fee): ez a díjtétel a kártyabirtokos bankjának díja (azaz a vásárló bankkártyáját kibocsátó bank), ami az Európán belül kibocsátott lakossági, betéti bankkártyák esetén <b>0,2</b>% -tól kezdődő mértékű.`,
        'ic_sup_2': `<b><sup class="sup-2">2</sup></b> <b>Kártyatársasági díj</b> (Card Scheme Fee): ennek a díjnak a mértéke <b>0,15% és 0,65%</b> között mozog, függően a tranzakció értékétől. Alacsony értékű tranzakció esetén ez a díjtétel magasabb, míg nagy értékű tranzakció esetén ez a díjtétel alacsonyabb.`,
        'ic_sup_3': `<b><sup class="sup-3">3</sup></b> <b>Kereskedői jutalék:</b> a feltüntetett kereskedői jutalékon felül még plusz <b>0,7%</b> is felszámításra kerül, ami az átlagos bankközi jutalékokat és kártyatársasági díjakat fedezi.<br>Minden hónap 15. napjáig eService egy korrekciós számlát küld az előző, lezárt hónap valós bankközi jutalékairól és kártyatársasági díjairól.<br>Ha a korrekciós számla pozitív előjelű, az azt jelenti, hogy a korábban levont <b>0,7%</b> nem fedezte teljesen a költségeket, így a számla végösszegét ráterhelik a következő utalásra.<br>Ha a korrekciós számla negatív előjelű, akkor a díjkedvezmény miatt a számla végösszegét jóváírják a következő utaláskor.`,
        'offer_validity': `Az ajánlat kizárólag 30 napig érvényes!`,
        'upload': 'Feltöltés',
        'close': 'Mégse',
        'add_new_person': 'Új személy hozzáadása',
        "contact_plans_alert": {
            "preloaded_data": "Központi cégadatbázisból előtöltöttük számodra az elérhető képviseletre jogosult (aláíró) és tulajdonosi adatokat, valamint az érdeklődéskor regisztrált kapcsolattartót. <br> Kérlek, a <strong>Szerkesztés</strong> gomb megnyomását követően állítsd be a személy pontos szerepkörét!<br> Ugyanaz a személy több szerepkört is betölthet.",
            "contact_person": "<strong>Kapcsolattartó</strong>: akit szerződéses és egyéb adminisztratív kérdésekben kereshetünk, telefonszám és e-mail cím megadása kötelező.",
            "authorized_representative": "<strong>Képviseletre jogosult</strong>: a szerződést aláíró, ez lehet önálló vagy együttes.<br> A képviseletre jogosult okmányainak adatait a <strong>Szerkesztés</strong> gomb megnyomását követően írd be a megfelelő helyekre, az okmányok másolatait töltsd fel kérlek!",
            "owner": "<strong>Tulajdonos</strong>:<br><ul style='margin-top: 8px; padding-left: 20px;'><li style='margin-bottom: 8px;'>Minden <strong>25%</strong> vagy azt meghaladó tulajdonosi részesedéssel rendelkező személyt tüntess fel! Ezen személyek okmányainak adatait a <strong>Szerkesztés</strong> gomb megnyomását követően írd be a megfelelő helyekre, az okmányok másolatait töltsd fel kérlek!</li><li>A <strong>25%</strong>-os részesedést el nem érő tulajdonosokat, akik más szerepet nem töltenek be, normál esetben nem szükséges beazonosítani, ezeket a személyeket törölheted!</li></ul>"
        },
        'bankAccountInfo': {
            'individual_info': 'Egyéni vállalkozó esetén saját névre szóló lakossági bankszámla is beállítható.',
            'iban_info': 'Erre a bankszámlára utaljuk a sikeres tranzakciók jutalékkal csökkentett összegét. Kérlek, add meg a teljes IBAN számlaszámot!',
            'iban_help': `Nem találod az IBAN-t a kivonaton? <a href="https://www.iban.hu/calculate-iban" target="_blank" class="primary--text">Kattints ide</a>, hogy kalkuláld az IBAN-t.`
        },
        'offer': {
            'title': 'Ajánlat',
            'section1': {
                'title': 'Az ajánlat elkészítése során az alábbi tényezőket vettük figyelembe:',
                'pos': {
                    'estimated_card_annual': 'Tervezett éves bankkártyás forgalom',
                    'avg_ticket_value': 'Átlagos vásárlási érték (kosárérték)',
                },
                'vpos': {
                    'estimated_card_annual': 'Tervezett éves bankkártyás forgalom',
                    'avg_ticket_value': 'Átlagos vásárlási érték (kosárérték)',
                },
                'nr_of_terminals': 'Terminálok darabszáma, típusa'
            },
            'section2': {
                'title': 'Bankkártya-elfogadásra vonatkozó ajánlatunk'
            },
            'reject': 'Elutasítom',
            'rejected': 'Ajánlat elutasítva',
            'accept': 'Elfogadom',
            'accepted': 'Ajánlat elfogadva',
            'info': 'Egyeztetni szeretnék',
            'waitingInfo': 'Egyeztetést kért',
            'egt': 'EGT tagállamai',
            'egt_link': 'https://en.wikipedia.org/wiki/European_Economic_Area',
            'eea': 'Európai Gazdasági Térség',
            'cardSchemeFee': 'Rendszerhasználati díj (Card Scheme Fee)',
            'interCharge': {
                'visa': 'InterChange díj Visa kártyák esetében',
                'masterCard': 'InterChange díj MasterCard kártyák esetében',
            },
            'recommendedProduct': 'A számodra ajánlott termék'
        },
        'success': {
            'dataModification': 'ADATMÓDOSÍTÁS',
            'thx': 'Köszönjük, hogy elfogadtad az ajánlatunkat!',
            'viaMail': 'Az ajánlatot elküldtük e-mailben is.',
            'redirect': `másodperc múlva átirányítunk a <br> a következő lépésre, ahol megadhatod a szerződéskötéshez szükséges adatokat.`,
            'nextStep': 'Tovább a szerződés adatok megadására',
        },
        'successSlovakia': {
            'title': 'Thank you!',
            'line_1': 'Dear Customer!',
            'line_2': 'Thank you for honoring us with your trust!',
            'line_3': 'The accepted payment acceptance offer has also been sent to you by e-mail.',
            'line_4': 'The next step is to prepare, finalize and sign your payment acceptance contract.',
            'line_5': 'To ensure that we can provide you with the service as soon as possible, please open the email and return the requested information and documents.',
            'line_6': 'If you have any questions, feel free to contact your sales contact!',
        },
        'dataRecording': {
            'title': 'SZERZŐDÉSADATOK RÖGZÍTÉSE',
            'contractData': 'Szerződéshez szükséges adatok',
            'finalSubmit': ' Kész, beküldöm az adatokat!',
            'confirmFinalSubmit': 'Végleges beküldés jóváhagyása',
            'confirmText': 'Biztos vagy benne, hogy a beírt adatok helyesek? Az "Kész, beküldöm az adatokat!" gomb megnyomása után már nem módosíthatod az adatokat!',
            'requestText': 'Kérjük az utolsó lépésben töltsd fel a szükséges dokumentumokat, vagy válasszd ki, hogy e-mailben szeretnéd elküldeni azokat.',
            'uploadingDocuments': 'Dokumentumok feltöltése',
            'close': 'Mégse',
            'back': 'Vissza',
            'next': 'Tovább',
            'addNewShop': 'További elfogadóhely hozzáadása',
        },
        'taxNumber': {
            'title': 'Kérjük add meg vállalkozásod adószámát',
            'label': 'Adószám',
            'specialLabel': 'Egyedi Adószám',
            'specialDesc': 'Egyedi adószám (például Őstermelői, vagy FEOR számmal rendelkezőknek)',
            'required': 'Az adószám megadása kötelező!',
            'length': 'Az adószám hossza 11 karakter kell, hogy legyen.',
        },
        'gdpr': {
            'title': 'ADATVÉDELMI BEÁLLÍTÁSOK',
            'subtitle': 'GDPR BEÁLLÍTÁSOK',
            'next': 'Tovább',
        },
        'offerHelp': {
            'title': 'Köszönjük!',
            'description': 'Kérlek gombnyomással reagálj az összes nyitott ajánlatra.',
        },
        'rejected': {
            'title': 'Sajnáljuk!',
            'description': 'Sajnáljuk, hogy ajánlatunk nem nyerte el a tetszésedet! Ilyen esetekben érdemes lehet újra felkeresned minket, hiszen lehetséges, hogy csak nem kaptunk elég információt az üzleti tevékenységedről, hisz minél több és pontosabb adat áll rendelkezésünkre, annál jobb ajánlatot tudunk adni neked!',
            'contact': 'Személyes kapcsolattartód elérhetősége:',
        },
        'dcc': {
            'title': ' DCC kimutatások',
            'subtitle': 'Kereskedések',
        },
        'login': {
            'title': 'ÜGYFÉLKAPU',
            'password': 'Jelszó',
            'remember_me': 'Emlékezz rám',
            'registration': 'Új regisztráció',
            'action': 'Bejelentkezés',
            'forgot_password': 'Elfelejtett jelszó',
            'tax_number_hint': 'Adószám első 8 karaktere',
        },
        'registration': {
            'title': 'AZONOSÍTÁS',
            'description_1': 'Jelszó létrehozásához kérjük azonosítsa magát adószáma első 8 karakterének a megadásával.',
            'description_2': 'Jelszó létrehozásához kérjük azonosítsa magát adószáma megadásával.',
            'action': 'IGÉNYLÉS',
            'back': 'Vissza',
        },
        'reset_password': {
            'title': 'JELSZÓ VISSZAÁLLÍTÁS',

            'new_password': {
                'label': 'Új Jelszó',
                'rules': {
                    'required': 'A jelszó megadása kötelező.',
                    'length': 'A jelszónak legalább 8 karaktert kell tartalmaznia.',
                },
            },

            'confirm_password': {
                'label': 'Jelszó megerősítése',
                'rules': {
                    'required': 'A jelszó megerösítése kötelező.',
                    'confirm': 'A jelszó megerősítése nem egyezik.',
                },
            },

            'action': 'Új jelszó beállítása'
        },
        'dashboard': {
            'shop': {
                'not_found': ' Jelenleg nincs terminál ebben az üzletben.'
            }
        },
        'eula': {
            'title': 'ÁSZF',
            'description': 'Általános Szerződési Feltételek\n',
        },
        "phoneNumberFiled": {
            "example": "Példa",
            "searchPlaceholder": "Keresés ország neve vagy hívókód alapján"
        },
        'acqCard': {
            'heading': 'Az Ön személyes kapcsolattartója:',
            'thankYou': 'Köszönjük, hogy érdeklődik szolgáltatásaink iránt',
            'provider': 'az Ön szolgáltatója',
        }
    },
    'sk.page': {
        'invalid_phone_number': 'Neplatné telefónne číslo',
        'required': 'Táto informácia je povinná',
        'yes': 'Áno',
        'no': 'Nie',
        'missing': 'Chýba',
        'uploaded': 'Nahrané',
        'pcs': 'db',
        'ok': 'OK',
        'save': 'Uložiť',
        'addNew': 'Pridať nové',
        'edit': 'Upraviť',
        'delete': 'Zmazať',
        'deleteTitle': 'Ste si istý, že chcete vymazať túto položku?',
        'deleteDesc': 'Tento úkon sa nedá neskôr zrušiť!',
        'deleteDocument': 'Zrušiť dokument',
        'aszf': 'Pozrieť Všeobecné zmluvné podmienky',
        'szep_card': `Naše terminály akceptujú aj karty SZÉP, Zdravotné poistné karty, ako aj karty American Express. Akceptovanie týchto kariet je podmienené zmluvou s príslušným vydavateľom karty, v ktorej sú stanovené poplatky vznikajúce pri prijatí.`,
        'szep_card_no_amex': `Naše terminály akceptujú všetky typy kariet SZÉP a Zdravotných kariet. Akceptovanie týchto kariet je podmienené zmluvou s príslušným vydavateľom karty, v ktorej sú stanovené poplatky vznikajúce pri prijatí.`,
        'ic_sup_1': `<b><sup class="sup-1">1</sup></b> <b>Medzibankový poplatok</b> (Interchange Fee): tento poplatok je účtovaný bankou držiteľa karty (tzn. bankou, ktorá vydala bankovú kartu zákazníka), ktorý pri spotrebiteľských debetných kartách vydaných v Európe začína od <b>0,2%</b>.`,
        'ic_sup_2': `<b><sup class="sup-2">2</sup></b> <b>Poplatok za platbu kartou </b> (Card Scheme Fee): tento poplatok sa pohybuje od 0,15% do 0,65% v závislosti od hodnoty transakcie. Pri nízkej hodnote transakcie je tento poplatok vyšší, zatiaľ čo pri vysokej hodnote transakcie je tento poplatok nižší.`,
        'ic_sup_3': `<b><sup class="sup-3">3</sup></b> <b>Obchodná provízia:</b> K uvedenej obchodnej provízii sa účtuje ďalších 0,7%, ktoré pokrýva priemerné medzibankové poplatky a poplatky za platbu kartou. Do 15. dňa každého mesiaca eService zašle opravnú faktúru za skutočné medzibankové poplatky a poplatky za platbu kartou z predchádzajúceho uzavretého mesiaca. Ak je opravná faktúra kladná, znamená to, že predtým odpočítaných 0,7% nepokrylo úplne náklady, takže konečná suma faktúry sa zaúčtuje v nasledujúcej platbe. Ak je opravná faktúra záporná, konečná suma faktúry bude vďaka zľave z poplatkov pripísaná k nasledujúcej platbe.`,
        'offer_validity': `Ponuka je platná iba 30 dní.`,
        'upload': 'Nahrať',
        'close': 'Nezrušte',
        'add_new_person': 'Pridať novú osobu',
        "contact_plans_alert": {
            "preloaded_data": "Z centrálnej databázy sme pre vás predvyplnili dostupné údaje o oprávnených zástupcoch (podpisujúcich osobách) a vlastníkoch, ako aj kontaktnú osobu registrovanú pri dopyte. Po stlačení tlačidla Upraviť prosím nastavte presnú úlohu osoby! Rovnaká osoba môže zastávať viacero úloh.",
            "contact_person": "Kontaktná osoba: osoba, ktorú môžeme kontaktovať v súvislosti so zmluvnými a administratívnymi záležitosťami, zadanie telefónneho čísla a e-mailovej adresy je povinné.",
            "authorized_representative": "Oprávnený zástupca: podpisujúca osoba zmluvy, môže byť samostatná alebo spoločná. Po stlačení tlačidla <strong>Upraviť</strong> zadajte údaje z dokumentov oprávneného zástupcu na príslušné miesta a nahrajte kópie dokumentov!",
            "owner": "Vlastník: uveďte všetky osoby s podielom <strong>25%</strong> alebo vyšším! <br> Po stlačení tlačidla <strong>Upraviť</strong> zadajte údaje z dokumentov týchto osôb na príslušné miesta a nahrajte kópie dokumentov! <br> Vlastníkov s podielom menším ako <strong>25%</strong>, ktorí nezastávajú inú úlohu, vo všeobecnosti nie je potrebné identifikovať a tieto osoby môžete vymazať!",
        },
        'bankAccountInfo': {
            'individual_info': 'V prípade živnostníka je možné nastaviť aj osobný bankový účet vedený na jeho meno.',
            'iban_info': 'Na tento bankový účet prevedieme sumu úspešných transakcií zníženú o províziu. Zadajte, prosím, celé číslo účtu IBAN!',
            'iban_help': `Neviete nájsť IBAN na výpise z účtu? <a href="https://www.iban.hu/calculate-iban" target="_blank" class="primary--text">Kliknite sem</a> na výpočet IBAN-u.`
        },
        'offer': {
            'title': 'Ponuka',
            'section1': {
                'title': 'Počas vyhotovenia ponuky sme brali do úvahy nasledujúce faktory:',
                'pos': {
                    'estimated_card_annual': 'Plánovaný ročný obrat platobnej karty ',
                    'avg_ticket_value': 'Priemerná hodnota nákupu (hodnota košíka)',
                },
                'vpos': {
                    'estimated_card_annual': 'Plánovaný ročný obrat platobnej karty ',
                    'avg_ticket_value': 'Priemerná hodnota nákupu (hodnota košíka)',
                },
                'nr_of_terminals': 'Počet a typ terminálov'
            },
            'section2': {
                'title': 'Naša ponuka na akceptovanie platobnej karty'
            },
            'reject': 'Odmietam',
            'rejected': 'Ponuka odmietnutá',
            'accept': 'Prijímam',
            'accepted': 'Ponuka prijatá',
            'info': 'Chcel(a) by som prejednať',
            'waitingInfo': 'Požiadal(a) o stretnutie',
            'egt': 'Členské štáty EHP',
            'egt_link': 'https://en.wikipedia.org/wiki/European_Economic_Area',
            'eea': 'Európsky hospodársky priestor',
            'cardSchemeFee': 'Poplatok za používanie systému (Card Scheme Fee)',
            'interCharge': {
                'visa': 'InterChange poplatok v prípade Visa kariet',
                'masterCard': 'InterChange poplatok v prípade MasterCard kariet',
            },
            'recommendedProduct': 'Vám ponúkaný produkt'
        },
        'success': {
            'dataModification': 'ZMENA ÚDAJOV',
            'thx': 'Ďakujeme, že ste prijali našu ponuku.',
            'viaMail': 'Ponuku sme poslali aj e-mailom.',
            'redirect': `sekúnd budete presmerovaný(á) na ďalší krok, kde môžete zadať údaje potrebné na uzavretie zmluvy.`,
            'nextStep': 'Ďalej na zadanie zmluvných údajov',
        },
        'successSlovakia': {
            'title': 'Ďakujeme!',
            'line_1': 'Vážený zákazník!',
            'line_2': 'Ďakujeme za prejavenú dôveru!',
            'line_3': 'Akcpetovaná ponuka na prijímanie platieb vám bola zaslaná aj e-mailom.',
            'line_4': 'Ďalším krokom je príprava, finalizácia a podpísanie zmluvy o prijímaní platieb.',
            'line_5': 'Aby sme vám mohli zabezpečiť službu čo najskôr, otvorte e-mail a dodajte nám prosím požadované informácie a dokumenty.',
            'line_6': 'Ak máte nejaké otázky, neváhajte nás kontaktovať.',
        },
        'dataRecording': {
            'title': 'ZAZNAMENÁVANIE ZMLUVNÝCH ÚDAJOV',
            'contractData': 'Údaje potrebné k zmluve',
            'finalSubmit': ' Konečné predloženie údajov',
            'confirmFinalSubmit': 'Schválenie konečného predloženia',
            'confirmText': 'Ste si istý(á), že zadané údaje sú správne? Po stlačení tlačidla "Schválenie konečného predloženia" už nebudete môcť údaje upravovať.',
            'requestText': 'V poslednom kroku, prosím, nahrajte potrebné dokumenty, alebo si vyberte možnosť ich zaslania e-mailom.',
            'uploadingDocuments': 'Nahrať dokumenty',
            'close': 'Zrušiť',
            'back': 'Späť',
            'next': 'Ďalej',
            'addNewShop': 'Pridať nový akceptačný bod',
        },
        'taxNumber': {
            'title': 'Prosím, zadajte DIČ Vášho podnikania',
            'label': 'DIČ',
            'specialLabel': 'Individuálne číslo',
            'specialDesc': 'Individuálne číslo (napr. pre primárnych výrobcov alebo pre tých, ktorí majú číslo medzinárodnej štandardnej klasifikácie zamestnaní)',
            'required': 'Zadanie DIČ je povinné.',
            'length': 'DIČ musí obsahovať 11 znakov.',
        },
        'gdpr': {
            'title': 'NASTAVENIE OCHRANY ÚDAJOV',
            'subtitle': 'GDPR NASTAVENIA',
            'next': 'Ďalej',
        },
        'offerHelp': {
            'title': 'Ďakujeme.',
            'description': 'Prosím, reagujte na všetky otvorené ponuky kliknutím na tlačidlo.',
        },
        'rejected': {
            'title': 'Ľutujeme.',
            'description': 'Je nám ľúto, že naša ponuka nesplnila vaše očakávania. V takýchto prípadoch sa oplatí nás znovu kontaktovať, keďže je možné, že sme nedostali dostatok informácií o Vašej podnikateľskej činnosti. Čím viac podrobných a presných informácií máme, tým lepšiu ponuku Vám môžeme poskytnúť.',
            'contact': 'Kontaktné údaje Vášho osobného zástupcu:',
        },
        'dcc': {
            'title': ' DCC výkazy',
            'subtitle': 'Obchody',
        },
        'login': {
            'title': 'KLIENTSKÁ BRÁNA',
            'password': 'Heslo',
            'remember_me': 'Pamätaj si ma',
            'registration': 'Nová registrácia',
            'action': 'Prihlásiť sa',
            'forgot_password': 'Zabudnuté heslo',
            'tax_number_hint': 'Prvých 8 znakov daňového čísla',
        },
        'registration': {
            'title': 'IDENTIFIKÁCIA',
            'description_1': 'Na vytvorenie hesla sa, prosím, identifikujte zadaním prvých 8 znakov vášho daňového čísla.',
            'description_2': 'Na vytvorenie hesla sa, prosím, identifikujte zadaním vášho daňového čísla.',
            'action': 'POŽIADAVKA',
            'back': 'Späť',
        },
        'reset_password': {
            'title': 'OBNOVIŤ HESLO',
            'new_password': {
                'label': 'Nové Heslo',
                'rules': {
                    'required': 'Heslo je povinné.',
                    'length': 'Heslo musí mať aspoň 8 znakov.',
                },
            },
            'confirm_password': {
                'label': 'Potvrdiť Heslo',
                'rules': {
                    'required': 'Potvrdenie hesla je povinné.',
                    'confirm': 'Potvrdenie hesla sa nezhoduje.',
                },
            },
            'action': 'Nastaviť Nové Heslo'
        },
        "dashboard": {
            "shop": {
                "not_found": "Momentálne v tomto obchode nie je žiadny terminál."
            }
        },
        'eula': {
            'title': 'Podmienky služby',
            'description': 'Všeobecné obchodné podmienky',
        },
        "phoneNumberFiled": {
            "example": "Príklad",
            "searchPlaceholder": "Hľadať podľa názvu krajiny alebo telefonického kódu"
        },
        'acqCard': {
            'heading': 'Váš osobný kontakt:',
            'thankYou': 'Ďakujeme za váš záujem o naše služby',
            'provider': 'váš poskytovateľ služieb',
        }
    },
}

